import type { RestaurantLite } from "../../src/types";
import { parkDisplayName } from "./parks";

const RESORT_PATTERNS: Array<[RegExp, string]> = [
  [/typhoon\s*lagoon/i, "Typhoon Lagoon"],
  [/blizzard\s*beach/i, "Blizzard Beach"],
  [/polynesian/i, "Polynesian"],
  [/grand\s*floridian/i, "Grand Floridian"],
  [/contemporary/i, "Contemporary"],
  [/boardwalk/i, "BoardWalk"],
  [/yacht|beach\s*club/i, "Yacht/Beach Club"],
  [/fort\s*wilderness/i, "Fort Wilderness"],
  [/coronado\s*springs/i, "Coronado Springs"],
  [/animal\s*kingdom\s*lodge/i, "Animal Kingdom Lodge"],
  [/old\s*key\s*west/i, "Old Key West"],
  [/saratoga\s*springs/i, "Saratoga Springs"],
  [/four\s*seasons/i, "Four Seasons"],
  [/swan|dolphin/i, "Swan & Dolphin"],
  [/wilderness\s*lodge/i, "Wilderness Lodge"],
  [/caribbean\s*beach/i, "Caribbean Beach"],
  [/port\s*orleans/i, "Port Orleans"],
  [/all-star/i, "All-Star"],
  [/pop\s*century/i, "Pop Century"],
  [/art\s*of\s*animation/i, "Art of Animation"],
  [/riviera/i, "Riviera"],
  [/dolphin/i, "Dolphin"],
];

export function deriveArea(r: Pick<RestaurantLite, "park" | "location">): string {
  if (
    r.park === "magic-kingdom" ||
    r.park === "epcot" ||
    r.park === "hollywood-studios" ||
    r.park === "animal-kingdom" ||
    r.park === "disney-springs"
  ) {
    return parkDisplayName(r.park);
  }
  for (const [re, label] of RESORT_PATTERNS) {
    if (re.test(r.location)) return label;
  }
  // fallback: first comma-segment of the location
  const seg = r.location.split(",")[0].trim();
  return seg || "Other";
}
